















import { Component, Vue } from 'vue-property-decorator'
import { EventBus } from "@/pitprojekt/event-bus";

@Component({})
export default class Snackbar extends Vue {
  snackbar: boolean = false;
  text: string = '';
  color: string = '';
  timeout: number = 5000;

  showSnackbar(text: string, type?: string ) {
    this.snackbar = true;
    this.text = text;
    this.color = (type != undefined) ? type : '';
  }

  created() {
    EventBus.$on('showSnackbarEvent', this.showSnackbar);
  }

}

